import React from "react";
// import {KeyboardArrowUp} from '@material-ui/icons';

import Error from '@material-ui/icons/Error';
import Refresh from '@material-ui/icons/Refresh';
import CheckCircle from '@material-ui/icons/CheckCircle';
import KeyboardReturn from '@material-ui/icons/KeyboardReturn';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Edit from '@material-ui/icons/Edit';
import CallMade from '@material-ui/icons/CallMade';
import Warning from '@material-ui/icons/Warning';
import SentimentSatisfied from '@material-ui/icons/SentimentSatisfied';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import Close from '@material-ui/icons/Close';
import Star from '@material-ui/icons/Star';

const MUIIcon = (props) => {
    const uiIcon = props.icon
    let Icon = null;

    if (uiIcon === 'Error') {
        Icon = Error
    } else if (uiIcon === 'Refresh') {
        Icon = Refresh
    } else if (uiIcon === 'CheckCircle') {
        Icon = CheckCircle
    } else if (uiIcon === 'KeyboardReturn') {
        Icon = KeyboardReturn
    } else if (uiIcon === 'ArrowDownward') {
        Icon = ArrowDownward
    } else if (uiIcon === 'ArrowUpward') {
        Icon = ArrowUpward
    } else if (uiIcon === 'SentimentSatisfied') {
        Icon = SentimentSatisfied
    } else if (uiIcon === 'Warning') {
        Icon = Warning
    } else if (uiIcon === 'CallMade') {
        Icon = CallMade
    } else if (uiIcon === 'Edit') {
        Icon = Edit
    } else if (uiIcon === 'KeyboardArrowUp') {
        Icon = KeyboardArrowUp
    } else if (uiIcon === 'KeyboardArrowDown') {
        Icon = KeyboardArrowDown
    } else if (uiIcon === 'Close') {
        Icon = Close
    } else if (uiIcon === 'Star') {
        Icon = Star
    }

    return <Icon data-tip data-for={props.dataFor || '' } className={`${props.className ? props.className : ''} material-icons`} />
}

export default MUIIcon;
